
(() => {
  const mobile = window.matchMedia("(max-width: 767px)");
  const selector = "[data-mobile-swipe]";
  const maxImages = 4;
  const minDistance = 35;
  const maxVerticalMovement = 60;

  let gesture = null;
  let blockClickUntil = 0;

  function getSlides(container) {
    return Array.from(
      container.querySelectorAll(
        "product-grid-item-image[data-grid-image]"
      )
    ).slice(0, maxImages);
  }

  function activateImage(slide) {
    if (!slide) return;

    const template = slide.querySelector("template");

    if (template) {
      slide.replaceChildren(
        template.content.cloneNode(true)
      );
    }

    const image = slide.querySelector("img");

    if (image) {
      image.loading = "eager";
    }
  }

  function getCurrentIndex(slides) {
    let current = slides.findIndex(
      slide => slide.hasAttribute("data-grid-current-image")
    );

    if (current < 0) {
      current = slides.findIndex(
        slide => slide.classList.contains("is-active")
      );
    }

    return current < 0 ? 0 : current;
  }

  function updateProgress(container, index, count) {
    const indicator = container.parentElement.querySelector(
  ".mobile-swipe-progress__indicator"
);

    if (!indicator || count < 2) return;

    const percentage = 100 / count;

    indicator.style.width = `${percentage}%`;
    indicator.style.left = `${index * percentage}%`;
  }

  function changeImage(container, direction) {
    if (!mobile.matches) return;

    const slides = getSlides(container);
    if (slides.length < 2) return;

    const current = getCurrentIndex(slides);

    const next = Math.max(
      0,
      Math.min(slides.length - 1, current + direction)
    );

    if (next === current) return;

    activateImage(slides[next]);

    slides.forEach((slide, index) => {
      const active = index === next;

      slide.classList.toggle("is-active", active);

      if (active) {
        slide.setAttribute("data-grid-current-image", "");
      } else {
        slide.removeAttribute("data-grid-current-image");
      }
    });

    updateProgress(container, next, slides.length);

    // Prepare the following image for a faster swipe.
    if (next + 1 < slides.length) {
      activateImage(slides[next + 1]);
    }
  }

  document.addEventListener("touchstart", event => {
    if (!mobile.matches || event.touches.length !== 1) {
      gesture = null;
      return;
    }

    const container = event.target.closest(selector);

    if (!container || getSlides(container).length < 2) {
      gesture = null;
      return;
    }

    const touch = event.touches[0];

    gesture = {
      container,
      x: touch.clientX,
      y: touch.clientY
    };
  }, { passive: true });

  document.addEventListener("touchend", event => {
    if (!gesture || !mobile.matches) return;

    const start = gesture;
    gesture = null;

    if (event.changedTouches.length !== 1) return;

    const touch = event.changedTouches[0];
    const dx = touch.clientX - start.x;
    const dy = touch.clientY - start.y;

    if (
      Math.abs(dx) < minDistance ||
      Math.abs(dy) > maxVerticalMovement ||
      Math.abs(dx) <= Math.abs(dy)
    ) {
      return;
    }

    changeImage(start.container, dx < 0 ? 1 : -1);

    blockClickUntil = Date.now() + 500;
  }, { passive: true });

  document.addEventListener("touchcancel", () => {
    gesture = null;
  }, { passive: true });

  document.addEventListener("click", event => {
    if (
      mobile.matches &&
      Date.now() < blockClickUntil &&
      event.target.closest(selector)
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      blockClickUntil = 0;
    }
  }, true);

  function initialiseProgressBars() {
    if (!mobile.matches) return;

    document.querySelectorAll(selector).forEach(container => {
      const slides = getSlides(container);
      if (slides.length < 2) return;

      const current = Math.min(
        getCurrentIndex(slides),
        slides.length - 1
      );

      updateProgress(container, current, slides.length);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseProgressBars
    );
  } else {
    initialiseProgressBars();
  }

  document.addEventListener(
    "shopify:section:load",
    initialiseProgressBars
  );

  mobile.addEventListener("change", () => {
    if (mobile.matches) initialiseProgressBars();
  });
})();


